import Vue from 'vue';
import Router from 'vue-router';
import CardOpen from '../components/card-open';

Vue.use(Router)

export default new Router({
    routes: [
        {
            name: 'card_open',
            path: '/:card_number',
            component: CardOpen
        }
    ],
    base: '/things-to-do-summer-2017/'
});



// WEBPACK FOOTER //
// ./src/router/index.js